import type { Listener } from '../types';

export default class StateManager<T> {
	private state: T;
	private listeners: Set<Listener<T>>;

	constructor(initialState: T) {
		this.state = initialState;
		this.listeners = new Set();
	}

	subscribe(listener: Listener<T>): () => void {
		this.listeners.add(listener);
		return () => this.listeners.delete(listener);
	}

	setState(newState: Partial<T>): void {
		this.state = { ...this.state, ...newState };
		this.listeners.forEach((listener) => listener(this.state));
	}

	getState(): T {
		return this.state;
	}
}
